import React from 'react'

const Spotlight = ({
  fill = 'black',
  width
}: {
  fill?: string
  width?: string
}) => (
  <svg
    width={width || '24px'}
    height={width || '24px'}
    viewBox="0 0 33 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.9998 6.66675C26.5521 6.66675 26.9998 7.11446 26.9998 7.66675V24.3334C26.9998 24.8857 26.5521 25.3334 25.9998 25.3334H6.66651C6.11422 25.3334 5.6665 24.8857 5.6665 24.3334V7.66675C5.6665 7.11446 6.11422 6.66675 6.6665 6.66675H25.9998ZM21.3332 8.00008C20.7809 8.00008 20.3332 8.4478 20.3332 9.00008V12.3334C20.3332 12.8857 20.7809 13.3334 21.3332 13.3334H24.6665C25.2188 13.3334 25.6665 12.8857 25.6665 12.3334V9.00008C25.6665 8.4478 25.2188 8.00008 24.6665 8.00008H21.3332Z"
      fill="black"
    />
  </svg>
)

export default Spotlight
